const Constants = {
  apiUrl:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3001/api"
      : "/api",
};

export default Constants;
